import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=330f05fe"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330f05fe')) {
      api.createRecord('330f05fe', component.options)
    } else {
      api.reload('330f05fe', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=330f05fe", function () {
      api.rerender('330f05fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/funders/Index.vue"
export default component.exports